import { useMutation } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { ProofreadingInput, ProofreadingOutput } from "@/types";

interface ProofreadBlocksVariables {
  input: ProofreadingInput;
  signal?: AbortSignal;
}

export function proofreadBlocks({ input, signal }: ProofreadBlocksVariables) {
  return apiFetch<ProofreadingOutput>("/v1/proofreading/check", {
    method: "POST",
    body: JSON.stringify(input),
    signal,
  });
}

export function useProofreadBlocks() {
  return useMutation({ mutationFn: proofreadBlocks });
}
